<template>
	<div class="all">
		<div  class="denglu_dl1">
			<div  class="denglu_dl2" v-if="zhanghui1==0">
				<div  class="denglu_dl3">
					<div class="iconfont iconrenwu denglu_dl4" ></div>
					<input type="text" placeholder="请输入手机号" v-model="form.zhanghao">
				</div>
				<div class="denglu_dl3_">
					<div class="iconfont iconmima denglu_dl4" ></div>
					<input type="text" placeholder="验证码" v-model="form.mima" class="wiinput">
					<div  class="denglu_dl10">获取验证码</div>
				</div>
				<div @click="xiaoyibu"  class="denglu_dl6">下一步</div>
			</div>
			<div  class="denglu_dl2" v-else>
				<div  class="denglu_dl3">
					<div class="iconfont iconmima denglu_dl4" ></div>
					<input type="text" placeholder="请输入新的密码" v-model="form.zhanghao">
				</div>
				<div class="denglu_dl3_">
					<div class="iconfont iconmima denglu_dl4" ></div>
					<input type="text" placeholder="再次输入密码" v-model="form.mima" class="wiinput">
		
				</div>
				<div @click="Tijiao"  class="denglu_dl6">确定</div>
			</div>
		</div>
	</div>
</template>

<script>
	var that;
	export default {
		data() {
			return {
				zhanghui1:0,
				form: {},
			}
		},
		created: function() {
			that = this;
		},
		methods: {
		xiaoyibu(){
			that.zhanghui1=1
		},
		}
	}
</script>

<style>
	.all {
		background: url(../../assets/denglu.png)no-repeat;
		background-size: cover;
		width: 100%;
		height: 100vh;
		position: relative;
	}

	input {
		background: none;
		outline: none;
		border: none;
	}
	.wiinput{width: 56%;}
.denglu_dl1{width:500px;height:400px;background:rgba(255,255,255,1);border-radius:30px;box-shadow:0px 0px 10px 0px rgba(224,224,224,1);position: absolute; margin-top: -200px;top: 50%;left: 50%;margin-left: -250px;}
.denglu_dl2{padding:85px  74px 0 83px ;}
.denglu_dl3{height: 60px;display: flex;border-bottom: 1px solid #EBEBEB;align-items: center;width: 320px;}
.denglu_dl3_{height: 60px;display: flex;border-bottom: 1px solid #EBEBEB;align-items: center;width: 320px;margin-bottom: 40px;}
.denglu_dl4{color: #00BFFF;font-size: 15px;padding-right: 19px;}
.denglu_dl5{height: 60px;display: flex;align-items: center;width: 320px;}
.denglu_dl6{width:360px;height:40px;background:rgba(0,123,255,1);border:1px solid rgba(26,114,254,1);border-radius:34px;display: flex;align-items: center;justify-content: center;margin: 0 auto;font-size:14px;color:rgba(255,255,255,1);font-weight:400;}
.denglu_dl7{display: flex;justify-content: center;padding-top: 20px;}
.denglu_dl8{font-size:9px;font-weight:400;color:rgba(153,153,153,1);}
.denglu_dl9{color: #007BFF;font-size:9px;font-weight:400;}
.denglu_dl10{display: flex;align-items: center;justify-content: center;color:rgba(0,123,255,1);font-weight:400;font-size:16px;border-radius:7px;border:1px solid rgba(0,123,255,1);height:25px;width:100px;}


</style>
